'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OffCanvas = function OffCanvas(_ref) {
  var _ref$width = _ref.width;
  var width = _ref$width === undefined ? 250 : _ref$width;
  var _ref$transitionDurati = _ref.transitionDuration;
  var transitionDuration = _ref$transitionDurati === undefined ? 250 : _ref$transitionDurati;
  var _ref$isMenuOpened = _ref.isMenuOpened;
  var isMenuOpened = _ref$isMenuOpened === undefined ? false : _ref$isMenuOpened;
  var _ref$position = _ref.position;
  var position = _ref$position === undefined ? "left" : _ref$position;
  var children = _ref.children;


  // transfer the <OffCanvas /> props to the children
  var transferProps = function transferProps(element) {
    return _react2.default.cloneElement(element, { width: width, transitionDuration: transitionDuration, isMenuOpened: isMenuOpened, position: position });
  };

  // transfer the props from OffCanvas to the child
  var offCanvasChildren = _react2.default.Children.map(children, transferProps);

  return _react2.default.createElement(
    'div',
    null,
    offCanvasChildren
  );
};

exports.default = OffCanvas;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-offcanvas/lib/OffCanvas.js
 ** module id = 814
 ** module chunks = 0
 **/